/**
 * Runs a function and returns its result.
 *
 * Equivalent to (() => {})()
 */
export const run = <TRet>(f: () => TRet) => f();
